import { styled } from "@mui/material";

export const StyledSingleValuesContainer = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: 1.571rem;
  flex: 1;
`;

export const StyledValue = styled("div")`
  display: flex;
  flex: 0 1 auto; /* don't grow, shrink if needed, auto width */
  overflow: hidden;
  text-overflow: ellipsis;
  align-items: center;
`;

export const StyledButtons = styled("div")`
  flex: 1 0 auto; /* grow if needed, don't shrink, auto width */
  display: flex;
  justify-content: end;
`;
